'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'chalkboard-user';
var width = 640;
var height = 512;
var aliases = ["chalkboard-teacher"];
var unicode = 'f51c';
var svgPathData = 'M192 352H128c-70.69 0-128 57.3-128 128c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32C320 409.3 262.7 352 192 352zM49.61 464C57.04 427.5 89.37 400 128 400h64c38.63 0 70.96 27.53 78.39 64H49.61zM160 320c53.02 0 96-42.98 96-96c0-53.02-42.98-96-96-96C106.1 128 64 170.1 64 224C64 277 106.1 320 160 320zM160 176c26.47 0 48 21.53 48 48S186.5 272 160 272S112 250.5 112 224S133.5 176 160 176zM584 0H216C185.1 0 160 25.12 160 56V80c0 13.25 10.75 24 24 24S208 93.25 208 80V56c0-4.406 3.594-8 8-8h368c4.406 0 8 3.594 8 8v304c0 4.406-3.594 8-8 8H528v-32c0-17.67-14.33-32-32-32H416c-17.67 0-32 14.33-32 32v32h-32c-13.25 0-24 10.75-24 24S338.8 416 352 416h232c30.88 0 56-25.12 56-56v-304C640 25.12 614.9 0 584 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChalkboardUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;